<template>
  <div class="discussions-view">
    <!--  <Component /> -->
  discussions


  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Discussionsiew',
  components: {
//    'GroupsView': () => import('@/views/holon/GroupsView'),

  },
}
</script>
<style>
.discussions-view {
  text-align: left;
}
</style>
